import React from 'react';
import './QrCode.sass';
import qr from '../../images/qr_92.png';
import qr2x from '../../images/qr_92@2x.png';
import data from '../../data';

const QrCode = ({text, type}) => {
    return (
        <div className={`qrCode ${type ? `qrCode--${type}` : ''}`}>
            <div className="qrCode__code">
                <img src={qr} srcSet={qr2x} alt={data.fixed.vk}/>
            </div>
            <div className="qrCode__text" dangerouslySetInnerHTML={{__html: text}}></div>
        </div>
    );
};

export default QrCode;
